import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-preview-dialog',
    templateUrl: './preview-dialog.component.html',
    styleUrls: ['./preview-dialog.component.scss'],
    standalone: false
})
export class PreviewDialogComponent {
    sanitizedUrl: any;
    title: string;
    constructor(
        private dialogRef: MatDialogRef<PreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { title?: string; name: string; url: string },
        private sanitizer: DomSanitizer
    ) {
        this.sanitizedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
        this.title = data.title || 'Preview';
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
